export default "__VITE_ASSET__bde9c34c__"